import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { NetworkServiceSelectorComponent } from './network-service-selector.component';
import { MatSelectModule } from '@angular/material/select';
import { MatIconModule } from '@angular/material/icon';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { ReactiveFormsModule } from '@angular/forms';
import { MatListModule } from '@angular/material/list';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';

@NgModule({
  declarations: [NetworkServiceSelectorComponent],
  imports: [
    CommonModule,
    MatSelectModule,
    MatIconModule,
    MatFormFieldModule,
    MatInputModule,
    ReactiveFormsModule,
    MatListModule,
  ],
  exports: [NetworkServiceSelectorComponent],
})
export class NetworkServiceSelectorModule {}
